import { Policy } from '@commandDrivenStateEngine/core/policies';
import { AccountState } from '../state';
import { AccountCommand } from '../commands';
import { ClientLibraryType } from '@bett3r-dev/teselly-client-library';
/**
 * Account Sync Policy
 *
 * Responsibilities:
 * - Subscribe to AccountsReadmodelType on init
 * - Dispatch data/set command when account data changes
 * - Cleanup subscription on unmount
 */
export const createAccountSyncPolicy = (
  backend: ClientLibraryType
): Policy<AccountState, AccountCommand> => ({
  name: 'account-sync',

  init: ({ dispatch }) => {
    console.log( '[account] Initializing account sync policy' );

    const close = backend.subscriptions.AccountsReadmodel({}, ( change: any ) => {
      // Snapshot: full state initialization from subscription
      if ( change?.type === 'snapshot' ) {
        dispatch(
          {
            type: 'account/data/set',
            payload: { account: change.data?.items?.[0] }
          },
          { source: 'api' }
        );
        return;
      }

      if ( change?.data ) {
        dispatch(
          {
            type: 'account/data/set',
            payload: { account: change.data }
          },
          { source: 'api' }
        );
      }
    });

    // Cleanup function
    return () => {
      console.log( '[account] Closing account sync subscription' );
      if ( close?.close ) {
        close.close();
      }
    };
  }
});
